import { Global } from '@emotion/react';

const Fonts = () => (
  <Global
    styles={`
      /* suit */
      @font-face {
        font-family: 'SUIT Variable';
        font-weight: 100 900;
        font-style: normal;
        font-display: swap;
        src: local('SUIT Variable'),
          url('/assets/fonts/woff2/SUIT-Variable.woff2') format('woff2-variations');
      } 
      @media screen and (min-width: 0em) {
        :root {
          font-size: 16px;
        }
      }     
      @media screen and (min-width: 30em) {
        :root {
          font-size: 20px;
        }
      }     
    `}
  />
);

export default Fonts;
